<template>
  <div class="app-container">
    <nav class="add-navigation">
      <div @click="$router.go(-1)" class="back-link">
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Vendor Products</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.go(-1)" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addVendor"
            >Add Vendor Product</primary-button
          >
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Add Vendor Product Information</span>
      <div class="col-wrapper">
        <div class="col">
          <primary-input
            type="text"
            name="vendor product name"
            class="field"
            v-model="vendor.vendor_product_name"
            v-validate="'required'"
            :class="{
              input: true,
              'is-danger': errors.has('vendor product name'),
            }"
            placeholder="Enter vendor product name"
          />
          <div class="help is-danger" v-if="errors.has('vendor product name')">
            {{ errors.first("vendor product name") }}
          </div>
        </div>
        <div class="col">
          <primary-select
            type="text"
            name="smsc"
            v-validate="'required'"
            v-model="vendor.smsc_id"
            :class="{ input: true, 'is-danger': errors.has('smsc') }"
            placeholder="type"
          >
            <option v-for="(i, k) in smscList" :value="i.smsc_id" :key="k">
              {{ i.smsc_id }}
            </option>
          </primary-select>
          <div v-if="errors.has('smsc')" class="help is-danger">
            {{ errors.first("smsc") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
  },
  data: () => ({
    api_adapters: [],
    vendor: {
      vendor_uuid: null,
      vendor_product_name: null,
      smsc_id: null,
    },
  }),
  computed: {
    ...mapGetters({
      smscList: "smsc/getSmscList",
    }),
  },
  async created() {
    await this.viewSmscList({});
  },
  methods: {
    ...mapActions({
      addVendorProduct: "vendorProduct/addVendorProduct",
      viewSmscList: "smsc/getSmscList",
    }),
    addVendor: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      try {
        this.vendor.vendor_uuid = this.$route.params.id;

        // const res = await this.addVendorProduct(this.vendor);
        await this.addVendorProduct(this.vendor);
        // console.log(res);

        this.$snotify.success("Vendor product has been added.", {
          timeout: 6000,
        });

        // this.$router.push({ name: "system-admin-vendor-accounts" });
        this.$router.push({
          name: "system-admin-vendor-accounts-list",
          params: {
            vendor_uuid: this.$route.params.id || null,
            vendor_name: this.$route.params.name,
          },
        });
      } catch (err) {
        if (err.response) {
          err =
            err.response.data.error && err.response.data.error.message
              ? err.response.data.error.message
              : err.response.data.errors;
        }
        this.$snotify.error(err, { timeout: 6000 });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 200px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: fit-content;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      padding-left: 15px;
      .col {
        width: 100%;
        padding: 0;
        margin-right: 15px;
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .upload-photo,
        #dropzone {
          min-height: 285px;
          min-height: 285px;
          border-radius: 4px;
          width: 100%;
          .dz-image {
            padding: 5px;
            img {
              height: 150px;
              width: 150px;
              border-radius: 50px;
            }
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .upload-contaioner {
          border: 1px solid #5171f3;
          border-radius: 4px;
          background-color: #ffffff;
          height: 265px;
          border-style: dashed;
          margin-right: 15px;
          position: relative;
          input[type="file"] {
            position: absolute;
            height: 36px;
            width: 136px;
            opacity: 0;
            cursor: pointer;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
            z-index: 1;
          }
          .upload-button {
            height: 36px;
            width: 136px;
            border-radius: 4px;
            background-color: #51a3f3;
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .company {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

